class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    const instructions = document.getElementById('predictive-search-instructions');

    if (instructions && this.input) {
      instructions.setAttribute('aria-hidden', 'true');
    
      this.input.addEventListener('focus', () => {
        instructions.removeAttribute('aria-hidden');
      });
    
      this.input.addEventListener('input', () => {
        instructions.setAttribute('aria-hidden', 'true');
      });
    
      this.input.addEventListener('blur', () => {
        instructions.setAttribute('aria-hidden', 'true');
      });
    }

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  getClientWidth() {
    const bodyElement = document.querySelector('body')
    return bodyElement ? bodyElement.clientWidth : 0
  }

  onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product,article&resources[options][fields]=title,product_type,vendor,body,tag`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.syncPredictiveSearchStatus();
        const showProductsButton = this.predictiveSearchResults.querySelector('.js-show-products-button')
        const showRecipesButton = this.predictiveSearchResults.querySelector('.js-show-recipes-button')
        const resultsPanel = this.predictiveSearchResults.querySelector('#predictive-search-results')
        const productsTab = this.predictiveSearchResults.querySelector('.js-products-results-container')
        const recipesTab = this.predictiveSearchResults.querySelector('.js-recipes-results-container')
        const viewMoreProducts = this.predictiveSearchResults.querySelectorAll('.js-search-view-more')
        const searchSection = document.querySelector('.js-main-search')
        const setResultsPanelLabel = (tabType) => {
          if (!resultsPanel) {
            return
          }
          const labelledById = tabType === 'products' ? showProductsButton?.id : showRecipesButton?.id
          if (labelledById) {
            resultsPanel.setAttribute('aria-labelledby', labelledById)
          }
        }
        const setTabState = (tabButton, isActive) => {
          if (!tabButton) {
            return
          }
          tabButton.classList.toggle('active', isActive)
          tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
          tabButton.setAttribute('tabindex', isActive ? '0' : '-1')
        }
        const setPanelState = (panel, isActive, desktopDisplay) => {
          if (!panel) {
            return
          }
          if (isActive) {
            panel.hidden = false
            panel.removeAttribute('aria-hidden')
            panel.style.display = window.innerWidth >= 1024 ? desktopDisplay : 'grid'
          } else {
            panel.hidden = true
            panel.setAttribute('aria-hidden', 'true')
            panel.style.display = 'none'
          }
        }
        const activateResultsTab = (tabType) => {
          const isProductsTab = tabType === 'products'
          setTabState(showProductsButton, isProductsTab)
          setTabState(showRecipesButton, !isProductsTab)
          setPanelState(productsTab, isProductsTab, 'flex')
          setPanelState(recipesTab, !isProductsTab, 'flex')
          setResultsPanelLabel(isProductsTab ? 'products' : 'recipes')
          if (searchSection) {
            searchSection.classList.toggle('products', isProductsTab)
            searchSection.classList.toggle('recipes', !isProductsTab)
          }
        }
        const syncTabAriaState = () => {
          if (!showProductsButton || !showRecipesButton) {
            return
          }
          if (showRecipesButton.classList.contains('active')) {
            setTabState(showProductsButton, false)
            setTabState(showRecipesButton, true)
            setResultsPanelLabel('recipes')
            return
          }
          if (showProductsButton.classList.contains('active')) {
            setTabState(showProductsButton, true)
            setTabState(showRecipesButton, false)
            setResultsPanelLabel('products')
            return
          }
          const recipesSelected = showRecipesButton.getAttribute('aria-selected') === 'true'
          setTabState(showProductsButton, !recipesSelected)
          setTabState(showRecipesButton, recipesSelected)
          setResultsPanelLabel(recipesSelected ? 'recipes' : 'products')
        }

        this.open();
        this.updateHeight()

        if (viewMoreProducts) {
          viewMoreProducts.forEach((oneViewMoreProductsButton) => {
            oneViewMoreProductsButton.addEventListener('click', () => {
              productsTab.style.maxHeight = 'fit-content'
              searchSection.style.maxHeight = 'unset'
              oneViewMoreProductsButton.style.display = 'none'
              if (window.innerWidth >= 1024) {
                searchSection.style.height = '100%'
              }
            })
          })
        }

        if (showProductsButton && showRecipesButton && productsTab && recipesTab) {
          showProductsButton.addEventListener('click', () => {
            activateResultsTab('products')
            this.updateHeight()
          })
          showRecipesButton.addEventListener('click', () => {
            activateResultsTab('recipes')
            this.updateHeight()
          })

          const tabs = [showProductsButton, showRecipesButton]
          const tabList = showProductsButton.closest('[role="tablist"]')
          if (tabList) {
            tabList.addEventListener('keydown', (event) => {
              const currentIndex = tabs.indexOf(document.activeElement)
              if (currentIndex === -1) return

              let newIndex = currentIndex
              switch (event.key) {
                case 'ArrowLeft':
                case 'ArrowUp':
                  newIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1
                  break
                case 'ArrowRight':
                case 'ArrowDown':
                  newIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1
                  break
                case 'Home':
                  newIndex = 0
                  break
                case 'End':
                  newIndex = tabs.length - 1
                  break
                default:
                  return
              }

              event.preventDefault()
              tabs[newIndex].focus()
              activateResultsTab(newIndex === 0 ? 'products' : 'recipes')
              this.updateHeight()
            })
          }

          syncTabAriaState()
        } else if (showProductsButton) {
          setResultsPanelLabel('products')
        } else if (showRecipesButton) {
          setResultsPanelLabel('recipes')
        }

        this.updateVisibleProductCards()


      })
      .catch((error) => {
        this.close();
        throw error;
      });

    fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,article&resources[options][fields]=title,product_type,vendor,body,tag`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        const results = data.resources.results
        const thereAreProducts = results.products.length !== 0
        const thereAreArticles = results.articles.length !== 0

        if (!thereAreArticles && !thereAreProducts) {
          this.showNoResults()
          this.updateHeight()
        } else {
          this.hideNoResults()
        }
      })
      .catch((error) => {
        console.error(error)
      })

    window.gtag &&
      window.gtag('event', 'predictive_search_query_new', {
        page_path: window.location.pathname,
        search_query: searchTerm
      })
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.showNoResults()
  }

  updateHeight() {
    const productsContainer = document.querySelector('.js-products-results-container')
    const searchSection = document.querySelector('.js-main-search')
    const wrapperHeight = `${(document.querySelector('.js-predictive-search-wrapper').offsetHeight + 20).toString()}px`
    if (window.innerWidth >= 1024) {
      searchSection.style.maxHeight = wrapperHeight
    } else {
      searchSection.style.maxHeight = 'calc(100% - var(--header-height))'
    }
    searchSection.style.overflowY = 'auto'

    if (productsContainer) {
      const hasOverflow = productsContainer.scrollHeight / productsContainer.clientHeight > 1.2 // this accounts for extra paddings that need to be added in
      if (hasOverflow) {
        document.querySelector('.js-search-view-more-desktop-container').style.display = 'flex'
      } else {
        document.querySelector('.js-search-view-more-desktop-container').style.display = 'none'
      }
    }
  }

  updateVisibleProductCards() {
    const container = document.querySelector('.js-products-results-container')

    if (!container) {
      return
    }

    const cards = document.querySelectorAll('.js-predictive-search-card')
    const tallestCardHeight = Math.max(...Array.from(cards).map(card => card.offsetHeight))

    container.style.maxHeight = this.getClientWidth() < 1024 ?
      `${tallestCardHeight * 3}px` :
      `${tallestCardHeight}px`

    cards.forEach((card) => {
      card.style.minHeight = `${tallestCardHeight}px`
    })
  }

  syncPredictiveSearchStatus() {
    const source = this.predictiveSearchResults.querySelector('#predictive-search-text');
    const status = document.getElementById('predictive-search-status');

    if (!source || !status) return;

    const text = source.textContent.trim();

    if (text && status.textContent !== text) {
      status.textContent = text;
    }
  }

  hideNoResults() {
    const noResults = document.querySelector('.js-no-search-results-container')
    noResults.style.display = 'none'
  }

  showNoResults() {
    const noResults = document.querySelector('.js-no-search-results-container')
    if (window.innerWidth >= 1024) {
      noResults.style.display = 'flex'
    } else {
      noResults.style.display = 'block'
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
